import React from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";

import CoreComponent20 from "../../../assets/Sub-component/CoreComponent20";
import CoreComponent2 from "../../../assets/Sub-component/CoreComponent2";
import Enterpertises2 from "../../../assets/Sub-component/Enterpertises2";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import deploy from "../../../assets/Flutter/Scalable-solution/Deployment.svg";
import solution from "../../../assets/Flutter/Scalable-solution/Solution.svg";
import culture from "../../../assets/Flutter/Scalable-solution/working culture.svg";

import dynamic from "../../../assets/Services/Web_design/Offer_custamizable/Dynamic_web.svg";
import resposnsive from "../../../assets/Services/Web_design/Offer_custamizable/Responsive_web.svg";
import WebDesigns from "../../../assets/Services/Web_design/Offer_custamizable/Web_design.svg";

import cusotm from "../../../assets/Services/Web_design/Partner_with/custom_web.svg";
import ecom from "../../../assets/Services/Web_design/Partner_with/Ecom_web.svg";
import mobile from "../../../assets/Services/Web_design/Partner_with/mobile_app_design.svg";
import uiuxs from "../../../assets/Services/Web_design/Partner_with/UIUX.svg";
import webspeed from "../../../assets/Services/Web_design/Partner_with/Web_speed.svg";
import wordpress from "../../../assets/Services/Web_design/Partner_with/wordpress_web.svg";

import CoreComponent14 from "../../../assets/Sub-component/CoreComponent14";
import WebDesignCore from "../../../assets/Sub-component/WebDesignCore";
import CoreComponent21 from "../../../assets/Sub-component/CoreComponent21";

import bug from "../../../assets/Services/Web_design/Why_choose/Bug_free.svg";
import code from "../../../assets/Services/Web_design/Why_choose/code.svg";
import customize from "../../../assets/Services/Web_design/Why_choose/Customize.svg";
import dynami from "../../../assets/Services/Web_design/Why_choose/Dynamic_market.svg";
import { Link } from "react-router-dom";

import custom from '../../../assets/Services/E-commerce_Service_Offerings/Custom_E-commerce.svg'
import commerce_App from '../../../assets/Services/E-commerce_Service_Offerings/E-commerce_App.svg'
import commerce_Platform from '../../../assets/Services/E-commerce_Service_Offerings/E-commerce_Platform.svg'
import Maintenance from '../../../assets/Services/E-commerce_Service_Offerings/Maintenance_&_Support.svg'
import Shopping_Cart_Development from '../../../assets/Services/E-commerce_Service_Offerings/Shopping_Cart_Development.svg'
import Web_Development_Customization from '../../../assets/Services/E-commerce_Service_Offerings/Web_Development_Customization.svg'

import Crafting_Your_Digital from '../../../assets/Services/Ecommerce_dev/Crafting_Your_Digital.png'
import Experience_Raidens from '../../../assets/Services/Ecommerce_dev/Experience_Raiden’s-E-commerce.png'
import Illustration from '../../../assets/Services/Ecommerce_dev/Illustration.png'
import launchingimage from '../../../assets/Launchingimage.png'

import compat from "../../../assets/Android-app-dev/Why-invest-in-android/Compatibility.svg";
import FaqHome from "../../../components/faq/FaqHome";
const EcommerceWebDevelopment = () => {
  const vertical = [
    {
      icon: compat,
      title: "Cost-effective",
      line: "line-hori",
    },
    {
      icon: ecom,
      title: "Building credibility",
      line: "line-hori",
    },
    {
      icon: mobile,
      title: "Strategic marketing",
      line: "line-hori",
    },
    {
      icon: uiuxs,
      title: "Supportive service",
      line: "line-hori",
    },
    {
      icon: webspeed,
      title: "Easy maintenance",
      
    },

 
  ];
  const content100 = [
    {
      icon: custom,
      title: "E-commerce App Development",
      desc: "We offer highly efficient mobile e-commerce apps for iOS and Android that enable customized user experiences, expand market reach, and enhance customer interaction. ",
    },
    {
      icon: commerce_App,
      title: "Custom E-Commerce Website Design",
      desc: "A unique e-commerce design that is both aesthetically appealing and incredibly functional for your particular business requirements is produced by Raiden's skilled team.",
    },
    {
      icon: Web_Development_Customization,
      title: "Web Development & Customization",
      desc: "We incorporate crucial features like marketing automation tools, CRM, and ERP to guarantee smooth operations in response to changing market demands and to give you total control.",
    },
    {
      icon: Shopping_Cart_Development,
      title: "Shopping Cart Development",
      desc: "We offer a secured and efficient solution integrating payment methods, data security, and other essential functions, ensuring the shopping cart is Raiden works hand in hand with clients. ",
    },
    {
      icon: Maintenance,
      title: "Maintenance & Support",
      desc: "We handle maintenance to guarantee continuous operations and maintain your website's position at the top of the market so you can concentrate on your main business.",
    },
    {
      icon: commerce_Platform,
      title: "E-commerce Platform Migration",
      desc: "Raiden guarantees a seamless transition with little interruption and no data loss. We plan and carry out migrations strategically, maintaining SEO value and offering a route forward for expansion.",
    },
  ];

  const innovative = {
    maintitle: "Experience Raiden’s E-commerce Website ",
    maindesc:
      "Choosing Raiden means collaborating with a partner who develops incredible websites that accelerate your business's expansion, builds strong online communities, and advances your enterprise with flawless execution and strategic accuracy.",

    loop: [
      {
        icon:customize ,
        title: "Customized Operations",
        desc: "Raiden's proficiency lies in configuring your e-commerce platform to your business needs. We provide solutions that integrate, enhance, and simplify your daily operations.",
      },
      {
        icon: dynami,
        title: "Dynamic Marketing Strategies",
        desc: "Raiden provides strong marketing techniques to create a positive online shopping experience. Our efficient SEO architect uses personalized campaigns and real-time analytics to increase reach and adapt your market strategy.",
      },

      {
        icon: code,
        title: "Powerful Code",
        desc: "We enable stable code so that your e-commerce website lies on a strong foundation. Experience fast loading, seamless operation even during peak traffic, enhanced security, and long-term flexibility to ensure your investment.",
      },

      {
        icon: bug,
        title: "Bug-Free Applications",
        desc: "We undergo extensive testing for quality control so that you can be sure the website is free of bugs. Creating a convenient online store where your clients can make frequent purchases.",
      },
    ],
  };

  const content = [
    {
      icon: solution,
      title: "Innovation & Future-Proofing",
      desc: "Raiden engineers emerging advancements like AI-driven personalization for relevant customer services. We commit to providing you a website that is both distinctive with regard to upcoming trends and highly scalable.",
      space: false,
    },
    {
      icon: culture,
      title: "Data-Driven Strategy",
      desc: "Our actionable insights guarantee that every section of your platform operates at peak efficiency. We prioritize Conversion Rate Optimization (CRO) and create a path for your business to increase profit while continuously supporting and driving traffic. ",
      space: false,
    },
    {
      icon: deploy,
      title: "Client-Centric Partnership",
      desc: "Raiden's works join hands with clients and understand your requirements to provide a meaningful solution. We are expert strategic consultants who provide expert suggestions on competitive analysis, market trends, and future growth opportunities.",
      space: false,
    },
  ];

  return (
<>
<img 
  src={launchingimage} 
  className="Bg-image"
  alt="Launching"
/>


    <div className="main-page-wrapper overflow-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />
      <div
        className=" container d-flex align-items-center justify-content-center flex-column height-vh topheader-margin"
      
      >
        <h1 className="h1-heading lh-sm fw-bold text-center">
          E-Commerce Website Development{" "}
        </h1>

        <p className="text-center mt-4 mb-4 h1-para lh-base">
          Raiden is the most effective Mobile App Development company,
          We are your dedicated partner in building stunning online stores that
          perform flawlessly with advanced technology, focusing on security,
          speed, and reliability so your business thrives.
        </p>
        <div className="d-flex ">
          <Link to="/request-quote">
            <button className="h1-para mt-lg-3 py-lg-3 py-2 px-lg-4 px-3 btn-gradient border-0 text-white rounded-4">
              Get Your Free Quote
            </button>
          </Link>
        </div>
      </div>

      <div className=" bg-light">
        <div className=" container pt-50 pb-50">
          <div className=" row mb-80 marb">
            <h2 className="col-lg-6 h2-heading lh-sm mb-3 mb-lg-0">
              Our E-commerce Service Offerings
            </h2>
            <p className="col-lg-6 h1-para lh-base">
              We at Raiden recognize your concern and offer you a user-friendly
              website that flourishes beyond a mere presence. Through a wide
              range of services, our design empowers your business and makes it
              possible for you to run smoothly.
            </p>
          </div>

          <div>
            <CoreComponent20 content={content100} />
          </div>
        </div>
      </div>

      <div className="container mt-80 mart ">
        <div className=" row">
          <div className="col-lg-6 text-center mb-4">
            <img src={Experience_Raidens} style={{ width: "75%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className=" h2-heading lh-sm">
              Experience Raiden’s E-commerce Website
            </h2>
            <p className="mt-4 h1-para lh-base" >
              At Raiden, we are proficient at building predominant websites that
              make you unique and efficient. Our deep knowledge of emerging
              technologies, security procedures, and continuous support enable
              us to maintain performance excellence. Raiden creates an
              easy-to-use e-commerce system in order to offer you a
              comprehensive service on your company website. We pledge to meet
              your company's needs for innovation and dependability so that it
              can dominate this digital environment. Our company provides the
              efficiency, dependability, and creativity required to succeed in
              the extremely competitive online market.
            </p>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart">
        <WebDesignCore vertical={vertical} />
      </div>

      <div className="container mt-80 mart ">
        <h2 className="mb-4 text-center h2-heading lh-sm ">
          Why Raiden Leads in E-commerce Development
        </h2>
        <p className="mb-40 mx-lg-4 h1-para lh-base" >
          Our constant dedication and optimistic approach lay the foundation for
          success. Raiden’s corporate excellence makes you stand unique with
          your e-commerce website.
        </p>

        <CoreComponent14 content={content} />
      </div>

      <div className="container mt-80 mart ">
        <div className=" row">
          <div className="col-lg-6">
            <h2 className="h2-heading lh-sm ">
              Crafting Your Digital Storefront with Raiden
            </h2>
            <p className="mt-lg-4 mt-3  h1-para lh-base" >
              Raiden is a captivating e-commerce experience designed to increase
              your customer base and boost your company's growth. E-commerce
              platforms are the foundation of your expansion that meets your
              business needs and customer performance. We maintain open
              communication with clients and ensure to provide informed
              decisions. We integrate your web-based store with social media,
              physical stores, and other platforms to offer a dependable and
              practical consumer experience.
            </p>
          </div>

          <div className="col-lg-6 text-center">
            <img src={Crafting_Your_Digital} style={{ width: "75%" }} alt="" />
          </div>
        </div>
      </div>

      <div className="container pb-80 padb mart  mt-80">
        <div className=" row">
          <div className="col-lg-6 text-center">
            <img
              src={Illustration}
              style={{ width: "75%" }}
              alt=""
            />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-sm mt-3 mt-lg-0">
              The Raiden Advantage: Benefits for Your E-commerce Business
            </h2>
            <p className="my-lg-4 my-3 ">
              Our talented developers create a user-friendly, intuitive website
              that thoroughly outlines your business's capabilities. We consider
              the client's requirements and recommendations and adjust our work
              accordingly to deliver a higher quality outcome.
            </p>
            <p className="my-lg-4 my-3 h1-para lh-base">
              Our streamlined development process facilitates internal teamwork,
              reduces errors, and provides real-time visibility. We demonstrate
              a proven track record of implementing websites to increase
              engagement and elevate your brand globally.
            </p>
            <ul className="list-dark ps-4 fs-6 h1-para lh-base">
              <li className="mb-2 ">
                An intuitive layout that facilitates navigation and boosts
                sales.{" "}
              </li>
              <li className="mb-2">
               Adjusted for optimal efficiency across all screen sizes.  
              </li>
              <li className="mb-2">
                Making sure data is secure and increasing productivity
              </li>
              <li className="mb-2">
                Meaningful e-commerce solutions to boost your return on
                investment.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart">
        <CoreComponent21 innovative={innovative} />
      </div>

      <div>
        <CoreComponent2 />
      </div>

      <div className="container text-center mt-80 mart">
        <h2 className="h2-heading lh-sm">Mastering the Full Spectrum of E-commerce </h2>
        <p className="my-3 h1-para lh-base">Excellence and Successful Execution</p>
        <Enterpertises2 />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default EcommerceWebDevelopment;
